/**
 * For implementation one needs an empty svg with the class .graph
 *
 * <svg class="graph"></svg>
 *
 * Use the following attributes to control the graph
 *
 * @param data-graph-value-type 		string 		%|decimal - type of the input values
 * @param data-graph-values				string 		comma separated list of values (eg: 2.2,1.5,30,102.4)
 *
 * @param data-graph-values-classes		string 		comma separated list of css-classnames from top to bottom
 * @param data-graph-default-class 		string 		default css-classname for bars. if no class given, this one is used.
 *
 * @param data-graph-values-colors 		string 		comma separated list of colors (fill) from top to bottom
 * @param data-graph-default-color 		string 		default color for bars. if no color given, this one is used.
 *
 * @param data-graph-labels 			string 		comma separated list of labels from top to bottom that will appear left of the bars.
 *
 * @param data-graph-end 				integer 	draw a vertical line to mark an end
 * @param data-graph-end-color			string	 	color of the vertical endline
 *
 * @param data-graph-oversize 			integer 	should the canvas be larger to give the values more room (horizontal space in percent. eg: 120 = 1.2 * calculatedSize)
 *
 * @param data-graph-height				integer		height of a bar
 * @param data-graph-margin-bottom		integer		bottom margin between the bars
 * @param data-graph-margin-top			integer		top margin between the bars
 *
 * @param data-graph-value-behind-bar	boolean		0|1 At which position should the value be displayed? Behind the bar (1) or behind the end-line (0)?
 *
 * Example integration
 *
 * <svg class="graph"
 * 	 width="100%"
 * 	 height="400"
 * 	 data-graph-value-type="decimal"
 * 	 data-graph-values="800,554,623,616,583,431,392"
 * 	 data-graph-values-classes="graph-bar-0, graph-bar-1"
 * 	 data-graph-values-colors="#a31924,#0f4c81"
 * 	 data-graph-labels="2025,2020,2019,2018,2017,2016,2016"
 * 	 data-graph-default-color="#798082"
 * 	 data-graph-default-class="graph-bar-default"
 * 	 data-graph-end="800"
 * 	 data-graph-end-color="#AFAFAF"
 * 	 data-graph-oversize="120"></svg>
 */

import {SdGraph} from "./SdGraph";

var timeoutID;

function initialize() {
	let graphs = [];
	document.querySelectorAll('.graph').forEach(graph => {
		graphs.push(new SdGraph(graph));
	});

	window.addEventListener('resize', event => {
		debounce(reInitializeGraphs, 200);
	});

	function debounce(func, timeout) {
		clearTimeout(timeoutID);
		timeoutID = window.setTimeout(reInitializeGraphs, 200);
	}

	function reInitializeGraphs() {
		graphs.forEach(graph => graph.initialize());
	}
}


document.addEventListener('DOMContentLoaded', initialize);